<template>
	<div class="mt-2 mx-2">
		<Header
			:loading="loading"
			:selectPlaceService="selectPlaceService"
			@setSelectPlaceService="setSelectPlaceService"
		/>

		<timeline-all class="mb-10" />

		<v-divider class="my-5"></v-divider>

		<places />
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Pusher from 'pusher-js';
import Header from '@/components/lodgings/Header';
import TimelineAll from '@/views/childrens/management/TimelineAll';
import Places from '@/views/Places';

export default {
	name: 'Inicio',
	components: {
		Header,
		TimelineAll,
		Places,
	},
	data() {
		return {
			pusher: null,
			channel: null,
			selectPlaceService: false,
		};
	},
	computed: {
		...mapGetters({
			loading: 'User/globalLoading',
			selectedPlace: 'Lodging/selectedPlace',
			places: 'Lodging/places',
			userProfile: 'User/profile',
		}),
	},
	created() {
		// El gestor de OT es responsive: aqui se usa el ancho real del dispositivo
		// en vez del lienzo fijo de 600px que encogia todo y bloqueaba el zoom.
		document
			.getElementById('viewport')
			.setAttribute('content', 'width=device-width, initial-scale=1.0');
		this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
			cluster: process.env.VUE_APP_PUSHER_CLUSTER,
		});
		this.pusher.connection.bind('update', function(err) {
			console.error(err);
		});
		this.channel = this.pusher.subscribe('lodging');
		this.channel.bind('update', data => this.$emit('fetch-lodgings', data));
		this.$on('fetch-lodgings', async data => {
			if (this.userProfile._id === data.idCompany) {
				this.setUpdateMap(true);
				// obtiene los lodgin de un place
				if (this.selectedPlace && this.$route.name == 'activities')
					setTimeout(() => {
						this.fetchLodgings(this.selectedPlace.value);
					}, 5);
				// obtiene los lodging de todo los lugares del admin "ver todos"
				else {
					await this.getLodgingsOfAdmin();
				}
				if (data.getPlace) {
					await this.fetchPlace();
				}
			}
		});
	},
	methods: {
		setSelectPlaceService(selected) {
			this.selectPlaceService = selected;
		},
		...mapActions({
			fetchPlace: 'Lodging/fetchPlace',
			fetchLodgings: 'Lodging/fetchLodgings',
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
		}),
		...mapMutations({
			setLodgings: 'Lodging/setLodgings',
			setUpdateMap: 'Lodging/setUpdateMap',
		}),
	},
};
</script>
